const COMMENT_REGEX = /<!--[\s\S]*?-->/g;
const removeComments = tokens => {
  return tokens.map(token => {
    // Only running for tokens of type html_block and html_inline
    // will prevent code from accidentally removing
    // comments within code blocks and inline code inputs
    if (token.type === 'html_block' || token.type === 'html_inline') {
      token.content = token.content.replace(COMMENT_REGEX, '').trim();
    }
    if (Array.isArray(token.children)) {
      token.children = removeComments(token.children);
    }
    return token;
  });
};

/**
 * Returns plugin that detects and removes html comment blocks.
 * Plugin will remove single and multi-line comments.
 * Will not remove comments that are displayed within code blocks.
 */
var HTMLComments = (() => ({
  plugin: md => {
    md.core.ruler.push('HTMLComment', _ref => {
      let {
        tokens
      } = _ref;
      return removeComments(tokens);
    });
  }
}));

export { HTMLComments as default };
